/* header-dual — scroll-to-solid, mobile drawer, cart, search */
(function () {
  if (customElements.get('header-dual')) return;

  class HeaderDual extends HTMLElement {
    connectedCallback() {
      this.translucent = this.dataset.translucent === 'true';
      this.threshold = parseInt(this.dataset.threshold, 10) || 50;
      this.ticking = false;

      if (this.translucent) {
        this.handleScroll();
        const onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => { this.handleScroll(); this.ticking = false; });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      }

      this.bindDrawer();
      this.bindCart();
      this.bindSearch();
    }

    handleScroll() {
      if (window.scrollY > this.threshold) this.classList.add('is-scrolled');
      else this.classList.remove('is-scrolled');
    }

    bindDrawer() {
      this.querySelectorAll('[data-bb-drawer-toggle]').forEach(btn => {
        const drawer = document.getElementById(btn.getAttribute('aria-controls'));
        if (!drawer) return;
        const setOpen = (open) => {
          drawer.classList.toggle('is-open', open);
          drawer.setAttribute('aria-hidden', String(!open));
          btn.setAttribute('aria-expanded', String(open));
          document.documentElement.classList.toggle('bb-no-scroll', open);
        };
        btn.addEventListener('click', () => setOpen(!drawer.classList.contains('is-open')));
        drawer.querySelectorAll('[data-bb-drawer-close]').forEach(c => c.addEventListener('click', () => setOpen(false)));
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setOpen(false); });
      });
    }

    bindCart() {
      const action = this.dataset.cartAction || 'page';
      const cartBtn = this.querySelector('[data-bb-cart-toggle]');
      if (!cartBtn || action === 'page') return; // default link behavior
      cartBtn.addEventListener('click', (e) => {
        const drawer = document.querySelector('cart-drawer, [data-bb-cart-drawer]');
        if (!drawer) return; // no drawer element (cart type ≠ drawer) → let the link go to /cart
        e.preventDefault();
        // Dawn's <cart-drawer> exposes .open(); fall back to its active classes.
        if (typeof drawer.open === 'function') {
          drawer.open();
        } else {
          drawer.classList.add('active', 'animate', 'is-open');
          document.body.classList.add('overflow-hidden');
        }
        document.documentElement.classList.add('bb-no-scroll');
      });
    }

    bindSearch() {
      const btn = this.querySelector('[data-bb-search-toggle]');
      const panel = this.querySelector('[data-bb-search]');
      if (!btn) return;
      if (!panel) { // no panel rendered → go to search page
        btn.addEventListener('click', () => { window.location.href = '/search'; });
        return;
      }
      const input = panel.querySelector('[data-bb-search-input]');
      const defaultBox = panel.querySelector('[data-bb-search-default]');
      const results = panel.querySelector('[data-bb-search-results]');
      const open = () => {
        this.classList.add('is-searching');
        panel.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('bb-no-scroll');
        setTimeout(() => input && input.focus(), 60);
      };
      const close = () => {
        this.classList.remove('is-searching');
        panel.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('bb-no-scroll');
      };
      btn.addEventListener('click', () => {
        this.classList.contains('is-searching') ? close() : open();
      });
      panel.querySelectorAll('[data-bb-search-close]').forEach((c) => c.addEventListener('click', close));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-searching')) close();
      });

      // ---- Predictive search ----
      if (!input || !results) return;
      let timer = null;
      const showDefault = () => { results.hidden = true; results.innerHTML = ''; if (defaultBox) defaultBox.hidden = false; };
      const render = (data) => {
        const r = (data.resources && data.resources.results) || {};
        const products = r.products || [];
        const collections = r.collections || [];
        const pages = r.pages || [];
        const articles = r.articles || [];
        let html = '';
        if (products.length) {
          html += '<p class="hdl-search__res-group-title">Products</p>';
          products.forEach((p) => {
            let img = p.image || (p.featured_image && p.featured_image.url) || '';
            if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=96';
            // No price in results — matches the /shop grid convention (title-only cards)
            html += `<a class="hdl-search__res" href="${p.url}">${img ? `<img src="${img}" alt="" width="48" height="48" loading="lazy">` : ''}<span class="hdl-search__res-title">${p.title}</span></a>`;
          });
        }
        const textGroups = [['Collections', collections], ['Pages', pages], ['Articles', articles]];
        textGroups.forEach(([label, list]) => {
          if (!list.length) return;
          html += `<p class="hdl-search__res-group-title">${label}</p>`;
          list.forEach((it) => {
            html += `<a class="hdl-search__res hdl-search__res--text" href="${it.url}"><span class="hdl-search__res-title">${it.title}</span></a>`;
          });
        });
        if (!html) html = '<p class="hdl-search__empty">No results. Try a different term.</p>';
        results.innerHTML = html;
        if (defaultBox) defaultBox.hidden = true;
        results.hidden = false;
      };
      const query = (q) => {
        const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then((res) => res.json())
          .then(render)
          .catch(() => {});
      };
      input.addEventListener('input', () => {
        const q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { showDefault(); return; }
        timer = setTimeout(() => query(q), 220);
      });
    }
  }

  customElements.define('header-dual', HeaderDual);
})();
